import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getCurrencySymbol = (currency) => {
  const symbols = {
    'BRL': 'R$',
    'EUR': '€',
    'USD': '$'
  };
  return symbols[currency] || 'R$';
};

export const fetchSettings = async () => {
  try {
    const response = await axios.get(`${API}/settings`);
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar configurações');
    return { currency: 'BRL' };
  }
};

export const formatCurrency = (value, currency = 'BRL') => {
  const symbol = getCurrencySymbol(currency);
  return `${symbol} ${value.toFixed(2)}`;
};